<template>
    <div class="symptom-manifestation">
        <div class="chart-row">
            <div v-if="hasSankey" class="chart-card w-1-2">
                <p class="chart-card-tit">症状表现桑基图</p>
                <disease-chart :option="sankeyOption" height="360px" />
            </div>
            <div class="chart-card w-1-2">
                <p class="chart-card-tit">症状表现知识图谱</p>
                <knowledge-graph :graph-data="chartData.symptomKnowledgeGraph" title="症状表现知识图谱" height="360px" />
            </div>
        </div>
    </div>
</template>

<script>
import DiseaseChart from './disease_chart.vue';
import KnowledgeGraph from './knowledge_graph.vue';
import { buildSankeyOption } from './buildSankeyOption';
export default {
    name: 'SymptomManifestation',
    components: { DiseaseChart, KnowledgeGraph },
    props: { chartData: { type: Object, default: () => ({}) } },
    computed: {
        hasSankey() {
            // 节点由 buildSankeyOption 从 links 自动提取，接口 data 缺失时只要有连线也应渲染。
            const sankey = this.chartData.symptomSankey;
            return !!(sankey && ((sankey.data && sankey.data.length) || (sankey.links && sankey.links.length)));
        },
        sankeyOption() { return buildSankeyOption(this.chartData.symptomSankey || {}); },

    },
};
</script>

<style lang="less" scoped>
.symptom-manifestation {
    .chart-row {
        display: flex;
        gap: 16px;
        align-items: stretch;
    }

    .chart-card {
        min-width: 0;
        background: #fff;
        border: 1px solid #E8EEF8;
        border-radius: 10px;
        padding: 12px 14px 16px;
        box-sizing: border-box;

        &.w-1-2 {
            flex: 1 1 0;
        }
    }

    .chart-card-tit {
        margin: 0 0 8px;
        font-size: 14px;
        font-weight: bold;
        color: #0C55AA;
        line-height: 20px;
    }
}
</style>
